import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { CROWN_EDIT, CROWN_UPDATE } from "../../routes/routes";
import { toast } from "react-toastify";
import { FullPageLoader } from "../../components/common/Loader"; // Import the loader component
import { CROWN_UPDATED } from "../../constant/constant";
import { Image } from "react-bootstrap";
import Select from "react-select";

const CROWN_TYPE_OPTIONS = [
  { value: 1, label: "Referrals" },
  { value: 2, label: "R2R" },
  { value: 3, label: "TYFCB" },
  { value: 4, label: "Visitors" },
  { value: 6, label: "Chief Guest" },
  { value: 7, label: "Inductions" },
  { value: 5, label: "Power Date" },
];

const CrownEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState();
  const [errors, setErrors] = useState({});

  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .put(CROWN_UPDATE + id, requestBody, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(CROWN_UPDATED);
          navigate("/crowns");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setBtnDisabled(false);
      });
  };
  useEffect(() => {
    axios
      .get(CROWN_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          let responseData = res.data.data;
          const typeOption = CROWN_TYPE_OPTIONS.find(
            (opt) => opt.value === Number(responseData?.type),
          );
          setForm({
            id: responseData?.id,
            title: responseData?.title,
            type: responseData?.type,
            type_selected: typeOption || null,
            cardImage: responseData?.image,
            status: responseData?.status,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);
  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading || btnDisabled} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Crowns</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/crowns"}>
                    <span>Crowns List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit Crown</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/crowns"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Edit Crown</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="title">
                          Title Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="title"
                          placeholder="Title Name"
                          onChange={(e) =>
                            setForm({ ...form, title: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, title: e.target.value })
                          }
                          defaultValue={form?.title}
                        />
                        <ValidationMessage error={errors} name="title" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="type">
                          Type<span className="text-danger">*</span>
                        </label>
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          name="type"
                          inputId="type"
                          options={CROWN_TYPE_OPTIONS}
                          value={form?.type_selected || null}
                          isDisabled
                          isClearable={false}
                        />
                        <ValidationMessage error={errors} name="type" />
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="d-flex justify-content-between">
                        <label htmlFor="image" className="form-label">
                          Crown Image(1:1)
                          <span className="text-danger">*</span> (ex. 200wx200h)
                        </label>
                        <div className="d-flex gap-3 image-info">
                          <div>
                            <label>Max :</label>
                            <span>2MB</span>
                          </div>
                        </div>
                      </div>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/jpeg, image/png, image/jpg"
                        onChange={(e) =>
                          e.target.files.length > 0
                            ? setForm({
                                ...form,
                                image: e.target.files[0],
                                cardImage: URL.createObjectURL(
                                  e.target.files[0],
                                ),
                              })
                            : ""
                        }
                      />

                      <div className="m-3">
                        <Image width={100} height={100} src={form?.cardImage} />
                      </div>
                      <ValidationMessage error={errors} name="image" />
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/crowns"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrownEdit;
